import { Component, Input } from '@angular/core';
import { BaseStepComponent } from 'app/base';
@Component({
  selector: 'pontuacao-total-resultados',
  templateUrl: './pontuacao-total-resultados.component.html',
  styles: [`
  .some-custom-class-name::ng-deep th {
          background-color: #b78c1c !important;
}`],
})
export class PontuacaoTotalResultadosComponent extends BaseStepComponent {
  @Input("listaValoresAtividadeSomatorio") valoresDataTableAtividadeSomatorio: any[];
  @Input() listaFuncao: any[];
  @Input() cabecalho: any[];
  @Input() isResultados: boolean = false;

  verificarDado(verificador: any): boolean {
    if (verificador == "id_funcao_exercida")
      return false;
    else
      return true;
  }
  verificarResultado(col: any, list: any[]): string {
    let pontuacao = this.getItemBy(list, { sigla: col });
    if (pontuacao == "") {
      let resultado = { id: 0, id_pontuacao: col, valor_pontuacao: 0, resultado: "N/A" };
      list.push(resultado);
      return "N/A";
    } else {
      return pontuacao.resultado;
    }
  }
  resultado(obj: any): string {
    let retorno = "";
    let nao_cumpriu = obj.resultado_prestacao_conta_pontuacao.find(x => x.resultado == "Não Cumpriu");
    let todos_nao_aplica = obj.resultado_prestacao_conta_pontuacao.find(x => x.resultado == "Não Cumpriu" || x.resultado == "Cumpriu");
    
    if (obj.resultado_final == null) {
      if (nao_cumpriu != undefined) {
        retorno = "Não Cumpriu";
        obj.resultado_final = retorno;
      } else if (todos_nao_aplica == undefined) {
        retorno = "N/A"; 
        obj.resultado_final = retorno;
      }
      else {
        retorno = "Cumpriu";
        obj.resultado_final = retorno;
      }
    }
    else {
      retorno = obj.resultado_final;
    }

    return retorno;
  }

}



// WEBPACK FOOTER //
// ./src/app/Componentes/pontuacao-total-resultados/pontuacao-total-resultados.component.ts